import { render } from "./titleTemplate.vue?vue&type=template&id=572397e0"
import script from "./titleTemplate.vue?vue&type=script&lang=js"
export * from "./titleTemplate.vue?vue&type=script&lang=js"

import "./titleTemplate.vue?vue&type=style&index=0&id=572397e0&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__